import { Controller } from '@hotwired/stimulus'
import * as bootstrap from 'bootstrap'

/**
 * Cart Switch Confirm Controller
 *
 * Shows a confirmation modal when switching to a saved cart while the current cart has items.
 * Gives the user options to:
 * - Keep current items (merge saved cart items into current cart)
 * - Replace current cart (switch to a copy of the saved cart)
 * - Cancel (do nothing)
 */
export default class extends Controller {
  static targets = ['modal', 'form', 'preserveField']

  connect() {
    this.modal = null
    this._initializeModal()
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose()
      this.modal = null
    }
  }

  showConfirm(event) {
    event.preventDefault()
    if (this.modal) {
      this.modal.show()
    }
  }

  keepItems(event) {
    event.preventDefault()
    this._hideModal()
    this.preserveFieldTarget.value = true
    this.formTarget.requestSubmit()
  }

  replaceItems(event) {
    event.preventDefault()
    this._hideModal()
    this.preserveFieldTarget.value = false
    this.formTarget.requestSubmit()
  }

  cancel(event) {
    event.preventDefault()
    this._hideModal()
  }

  _initializeModal() {
    if (this.hasModalTarget) {
      const bs = this._resolveBootstrapLibrary()
      if (bs?.Modal) {
        this.modal = bs.Modal.getOrCreateInstance(this.modalTarget)
      }
    }
  }

  _hideModal() {
    if (this.modal) {
      this.modal.hide()
    }
  }

  _resolveBootstrapLibrary() {
    return bootstrap.Modal ? bootstrap : window.bootstrap
  }
}
